import { createSlice } from "@reduxjs/toolkit";

export const warehousesProductionInitialState = {
  filters: {
    brandIds: [],
    subjectIds: [],
    productIds: [],
    barcodeIds: [],
    categoryIds: [],
  },

  excludeBarcodeSet: [], // stored as an array bc rtk doesn't store sets :(
};

const warehousesProductionSlice = createSlice({
  name: "warehousesProduction",
  initialState: warehousesProductionInitialState,
  reducers: {
    updateFilter(state, action) {
      const { filterName, value } = action.payload;
      state.filters[filterName] = value;
    },
    resetFilters(state) {
      state.filters = warehousesProductionInitialState.filters;
    },
    updateExcludeBarcodeSet(state, action) {
      state.excludeBarcodeSet = action.payload;
    },
  },
});

export const { updateFilter, resetFilters, updateExcludeBarcodeSet } =
  warehousesProductionSlice.actions;

export default warehousesProductionSlice.reducer;
